<template>
  <div class="container">
    <header class="jumbotron">
      <h3>
        <!-- <b-icon icon="hand-index-thumb"></b-icon> -->
        {{content}}
        <b-icon icon="file-post-fill"></b-icon>
      </h3>
    </header>
  </div>
</template>

<script>
//import UserService from '../services/user.service';

export default {
  name: 'Home',
  data() {
    return {
      content: 'Halo, silahkan pilih menu diatas untuk aktivitas Picking'
    };
  },
  mounted() {
    /*
    UserService.getPublicContent().then(
      response => {
        this.content = response.data;
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
     */
  }
};
</script>
